<template>
  <div>
    <LandDynamicBanner></LandDynamicBanner>
    <div class="news-div">
      <div
        class="news-content"
        v-for="(item, index) in newsList"
        :key="index"
      >
        <div class="news-content-img"><img :src="item.imageUrl"></div>
        <div class="news-content-text">
          <div style="height:129px">
            <div class="content-title" @click="newsClick(item.referringSite)">
              <div
                v-for="(desc,index) in item.title.split('\n')"
                :key="index"
              >{{desc}}</div>
            </div>
            <div class="content-text">{{item.description}}</div>
          </div>
          <div class="content-btn">
            <el-button
              class="news-btn"
              @click="newsClick(item.referringSite)"
            >查看详情</el-button>
          </div>
        </div>
      </div>
      <div class="page-div">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="pageData.pageNum"
          :total="pageData.pageCount"
          :page-size="pageData.pageSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LandDynamicBanner from './components/LandDynamicBanner.vue'
import { scrollTopFun } from '@/utils/universalFun.js'
import { getNews } from '@/api/landing'
export default {
  name: 'LandDynamic',
  components: {
    LandDynamicBanner
  },
  mounted () {
    this.getList()
  },
  data () {
    return {
      newsList: [],
      pageData: {
        pageNum: 1,
        pageCount: 0,
        pageSize: 6
      }
    }
  },
  methods: {
    // 获取列表
    getList () {
      // 查询平台动态，默认查询第一页
      getNews(this.pageData)
        .then(res => {
          const { code, data, message } = res
          if (code === 200) {
            this.newsList = data.list || []
            this.pageData.pageCount = data.count
          } else {
            this.newsList = []
            message && this.$message.error(message)
          }
        })
        .catch(() => {
          this.newsList = []
        })
    },
    // 点击平台动态
    newsClick (newsUrl) {
      window.open(newsUrl, '_blank')
    },
    // 分页切换
    handleCurrentChange (val) {
      this.pageData.pageNum = val
      this.getList()
      this.toTop()
    },
    // 回到顶部
    toTop () {
      scrollTopFun()
    }
  }
}
</script>

<style lang="scss" scoped>
.news-div {
  width: 1200px;
  margin: 0px auto 56px auto;
  .news-content {
    width: 1200px;
    height: 264px;
    background: #ffffff;
    box-shadow: 0px 3px 8px 4px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    margin-top: 42px;
    display: flex;
    .news-content-img {
      width: 400px;
      height: 224px;
      margin: 19px 65px 19px 19px;
      // background-color: brown;
      img {
        width: 400px;
        height: 224px;
      }
    }
    .news-content-text {
      height: 263px;
      .content-title {
        width: 648px;
        max-height: 66px;
        font-size: 24px;
        font-weight: 500;
        color: #181f42;
        line-height: 33px;
        margin-top: 39px;
      }
      .content-title:hover{
        cursor: pointer;
        color: #4499ff;
      }
      .content-text {
        width: 648px;
        height: 48px;
        font-size: 14px;
        font-weight: 400;
        color: #5c5c65;
        line-height: 24px;
        margin-top: 15px;
        //控制显示文字的行数
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .content-btn {
        margin-top: 29px;
        .news-btn {
          width: 99px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #4499ff;
          font-size: 14px;
          font-weight: 400;
          color: #4499ff;
          line-height: 22px;
        }
        .news-btn:hover {
          background: #4499ff;
          color: #ffffff;
        }
      }
    }
  }
  .news-content:hover {
    box-shadow: 0px 5px 13px 7px rgba(0, 0, 0, 0.06);
  }
  .page-div {
    margin: 48px auto 0px auto;
    -webkit-user-select: none; /*谷歌 /Chrome*/
    -moz-user-select: none; /*火狐/Firefox*/
    -ms-user-select: none; /*IE 10+*/
    user-select: none;
    ::v-deep .el-pagination {
      justify-content: center !important;
    }
    ::v-deep .el-pagination__total {
      display: none;
    }
    ::v-deep .el-pager li {
      font-size: 14px;
      font-weight: 400;
      color: rgba(31, 31, 31, 0.8);
      border: 1px solid #dedede;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #ffffff;
      border: 1px solid #4499ff;
      color: #4499ff;
    }
    ::v-deep .el-pagination.is-background .btn-prev {
      border: 1px solid #dedede;
    }
    ::v-deep .el-pagination.is-background .btn-next {
      border: 1px solid #dedede;
    }
  }
}
</style>
